export default __webpack_public_path__ + "static/media/google.c1c17a3e.svg";